"use client";
import Link from "next/link";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { RiverLogoSmall } from "~/components/v3/themed/Logo";
import { cn } from "~/utils/fontsConfig";
import { FooterCreateEventButton } from "./FooterClientButtons";
import { PageWrapper } from "~/components/v4/themed/wrappers/PageWrapper";

const Footer = () => {
    return (
        <PageWrapper>
            <footer
                className={cn(
                    "w-full bg-black py-12",
                    "mb-5 sm:mb-0",
                    "md:pb-0",
                )}
            >
                <div className="mt-12 pt-6">
                    <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
                        {/* Logo */}
                        <div className="flex flex-col items-center gap-2 md:flex-row md:gap-6">
                            <div className="flex h-6 w-6 items-center justify-center overflow-hidden">
                                <RiverLogoSmall />
                            </div>
                            <FooterCreateEventButton />
                            <div className="flex flex-wrap justify-center gap-4 md:gap-6">
                                <Link
                                    key="about"
                                    href="https://www.getriver.io"
                                    className="transition-colors hover:text-white/80"
                                    target="_blank"
                                >
                                    About River
                                </Link>
                                <Link
                                    key="pricing"
                                    href="https://www.getriver.io/pricing"
                                    className="transition-colors hover:text-white/80"
                                    target="_blank"
                                >
                                    Pricing
                                </Link>
                                <Link
                                    key="help"
                                    href="https://intercom.help/rvr/en"
                                    className="hidden transition-colors hover:text-white/80 md:block"
                                    target="_blank"
                                >
                                    Help Center
                                </Link>
                                <Link
                                    key="newsletter"
                                    href="https://thecurrentbyriver.substack.com/"
                                    className="transition-colors hover:text-white/80"
                                    target="_blank"
                                >
                                    Newsletter
                                </Link>
                            </div>
                        </div>

                        {/* Social icons */}
                        <div className="flex flex-wrap justify-center gap-4">
                            <Link
                                href="https://twitter.com"
                                aria-label="Twitter"
                                className="flex h-[40px] w-[40px] items-center justify-center gap-4 rounded-lg bg-[#121418] text-white hover:bg-[#121418]/70 hover:text-white"
                            >
                                <FaXTwitter size={18} />
                            </Link>
                            <Link
                                href="https://facebook.com"
                                aria-label="Facebook"
                                className="flex h-[40px] w-[40px] items-center justify-center gap-4 rounded-lg bg-[#121418] text-white hover:bg-[#121418]/70 hover:text-white"
                            >
                                <FaFacebook size={18} />
                            </Link>
                            <Link
                                href="https://instagram.com"
                                aria-label="Instagram"
                                className="flex h-[40px] w-[40px] items-center justify-center gap-4 rounded-lg bg-[#121418] text-white hover:bg-[#121418]/70 hover:text-white"
                            >
                                <FaInstagram size={18} />
                            </Link>
                            <Link
                                href="https://linkedin.com"
                                aria-label="LinkedIn"
                                className="flex h-[40px] w-[40px] items-center justify-center gap-4 rounded-lg bg-[#121418] text-white hover:bg-[#121418]/70 hover:text-white"
                            >
                                <FaLinkedin size={18} />
                            </Link>
                            <Link
                                href="https://youtube.com"
                                aria-label="YouTube"
                                className="flex h-[40px] w-[40px] items-center justify-center gap-4 rounded-lg bg-[#121418] text-white hover:bg-[#121418]/70 hover:text-white"
                            >
                                <FaYoutube size={18} />
                            </Link>
                        </div>
                    </div>
                </div>
            </footer>
        </PageWrapper>
    );
};

export default Footer;
